// Ally fallback answers (used when /api/ally is unreachable).
// Pure data lives in ./data/ally-fallbacks.json — patterns are strings + flags
// so the file is editable without TypeScript knowledge. Compiled to RegExp here.

import data from './data/ally-fallbacks.json';

export interface AllyFallback {
  pattern: RegExp;
  answer: string;
}

export const allyFallbacks: ReadonlyArray<AllyFallback> = data.patterns.map(
  (p) => ({ pattern: new RegExp(p.match, p.flags), answer: p.answer })
);

export const allyGenericFallback: string = data.genericFallback;
